import React, { useContext, useState } from 'react';
import { Card, Col, Nav, Row, Tab } from 'react-bootstrap';
import TblOpenPay from '../../finanzas/TblOpenPay';
import { useParams } from 'react-router-dom';
import SuscripcionesUser from './SuscripcionesUser';
import TblConekta from '../../finanzas/TblConekta';
import { checkAccess } from '../../../helpers/details';
import { AuthContext } from '../../../auth/AuthContext';

const PasarelasUs = () => {
    const [activeTab, setActiveTab] = useState('openpay');
        const { auth } = useContext(AuthContext);
    
    const handleTabChange = (selectedKey) => setActiveTab(selectedKey);
     const permisos = checkAccess('Facturación', auth.accesos);
        const {
            pasarelas} = permisos.functions
    const { id } = useParams();
    let idR = atob(id);
    return (
        <div>
            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                           {pasarelas ? <Tab.Container defaultActiveKey="openpay" activeKey={activeTab} onSelect={handleTabChange}>
                                <Nav variant="tabs" className="nav-bordered" as="ul">
                                    <Nav.Item as="li">
                                        <Nav.Link eventKey="openpay">
                                            <i className="mdi mdi-cash" /> OpenPay
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link eventKey="conekta">
                                            <i className="mdi mdi-cash" /> Oxxo
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link eventKey="suscript">
                                            <i className="mdi mdi-cards" />
                                            Suscripciones
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>

                                <Tab.Content>
                                    <Tab.Pane eventKey="openpay">
                                        <TblOpenPay id={idR} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="conekta">
                                        <TblConekta id={idR} />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="suscript">
                                        <SuscripcionesUser id={idR} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </Tab.Container>:<h2>Sin acceso</h2>}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default PasarelasUs;
